import { CommentAttachments } from "@jugl-web/domain-resources/tickets";
import { Avatar } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useFormattedDate } from "@jugl-web/utils/hooks/useFormattedDate";
import { FC, ReactNode } from "react";

export interface CommentListItemProps {
  username: string;
  userImageUrl: string | null;
  message: ReactNode;
  date: Date;
  isEdited?: boolean;
  attachments?: string[];
  onAttachmentClick?: (url: string, allUrls: string[]) => void;
  onDownload?: (url: string) => void;
  contextMenuSlot?: ReactNode;
}

export const CommentListItem: FC<CommentListItemProps> = ({
  username,
  userImageUrl,
  message,
  date,
  isEdited,
  attachments,
  onAttachmentClick,
  onDownload,
  contextMenuSlot,
}) => {
  const { humanizePastDate } = useFormattedDate();
  const { t } = useTranslations();

  return (
    <div className="flex gap-3 border-0 border-b border-solid border-grey-200 p-6">
      <Avatar
        size="md"
        username={username}
        imageUrl={userImageUrl}
        className="h-8 w-8 shrink-0 border border-solid border-grey-200"
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="mb-2 flex items-start justify-between gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <span className="truncate font-secondary text-sm leading-2 font-semibold text-[#363636]">
              {username}
            </span>
            <div className="flex shrink-0 items-center gap-1 font-secondary text-xs text-grey-900">
              {isEdited && (
                <>
                  <span>
                    {t({ id: "common-edited", defaultMessage: "Edited" })}
                  </span>
                  <span>•</span>
                </>
              )}
              <span>{humanizePastDate(date)}</span>
            </div>
          </div>
          {contextMenuSlot}
        </div>
        <div className="jugl__break-word font-secondary text-sm leading-[140%] whitespace-pre-wrap text-dark">
          {message}
        </div>
        {attachments && attachments.length > 0 && (
          <CommentAttachments
            attachments={attachments}
            onAttachmentClick={onAttachmentClick}
            onDownload={onDownload}
          />
        )}
      </div>
    </div>
  );
};
